import { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'

export function FormJsonToShamsiTime(value) {
    if (!value) return ''
    
    try {
        // پارس کردن تاریخ ISO به صورت دستی
        const isoRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3}))?Z$/;
        const match = value.match(isoRegex);
        
        if (!match) {
            console.error('فرمت تاریخ ISO نامعتبر است:', value);
            return '';
        }
        
        // استخراج اجزای تاریخ و زمان
        const [, year, month, day, hour, minute, second] = match;
        
        // ساخت آبجکت DateObject مستقیماً از اعداد استخراج شده
        // ساخت یک تاریخ گرگوری با مقادیر مشخص (بدون تبدیل به Date جاوااسکریپت)
        const date = new DateObject({
            year: parseInt(year),
            month: parseInt(month),
            day: parseInt(day),
            hour: parseInt(hour),
            minute: parseInt(minute),
            second: parseInt(second),
            format: "YYYY-MM-DD HH:mm:ss",
            // تنظیم تقویم به گرگوری که با فرمت ISO سازگار است
            calendar: "gregorian"
        });
        
        // تبدیل به منطقه زمانی تهران (اضافه کردن 3:30 ساعت)
        // ایران 3:30 ساعت جلوتر از UTC است
        date.add(3, "hour").add(30, "minute");
        
        // بازگرداندن زمان با فرمت ساعت:دقیقه
        return date.format('HH:mm');
    } catch (error) {
        console.error('خطا در تبدیل زمان:', error);
        return '';
    }
}
